import React from 'react';
import { Link } from 'react-router-dom';
import ProfileAvatar from '../common/ProfileAvatar';
import { AllianceOverview } from '../../types/alliance';

interface AlliancesHeadshotsProps {
  alliances: AllianceOverview[];
  allianceCount: number;
  maxDisplayed?: number;
  maxCount?: number;
  avatarSize?: string;
  className?: string;
}

const AlliancesHeadshots: React.FC<AlliancesHeadshotsProps> = ({
  alliances,
  allianceCount,
  maxDisplayed = 10,
  maxCount = 10,
  avatarSize = 'w-6 h-6',
  className = '',
}) => {
  const recentAlliances = alliances.slice(0, maxDisplayed);
  const remainingCount = Math.min(allianceCount - recentAlliances.length, maxCount);

  return (
    <div className={`flex gap-1 ${className}`}>
      {recentAlliances.map(alliance => (
        <Link to={`/freelancers/${alliance.profile_id}`} key={alliance.profile_id}>
          <ProfileAvatar
            profile_id={alliance.profile_id}
            first_name={alliance.first_name}
            avatar_url={alliance.avatar_url}
            className={avatarSize}
          />
        </Link>
      ))}
      {remainingCount > 0 && (
        <div
          className={`${avatarSize} rounded-full flex items-center justify-center text-secondary bg-gray-100`}
        >
          <span className="text-xs font-medium">{remainingCount}+</span>
        </div>
      )}
    </div>
  );
};

export default AlliancesHeadshots;
